import axios from 'api/axios-configure'
import { Grid } from "@mui/material"
import { AlertBanner, AlertBannerText, Button, Tooltip } from "monday-ui-react-core"
import { useContext, useEffect, useMemo, useState } from "react"
import OrganizationLinksModal from "./OrganizationLinksModal"
import { UITableReport } from 'components/UITableReport'
import { AuthSessionContext } from 'api/AuthSession'
import { Trash3 } from 'react-bootstrap-icons'

const OrganizationLinks = ({changedOrg}) => {
    const { IS_USER } = useContext(AuthSessionContext)

    const [openModal, setOpenModal] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isFetching, setIsFetching] = useState(false)
    const [displayBanner, setDisplayBanner] = useState(false)
    const [bannerMessage, setBannerMessage] = useState('')
    const [bannerStyle, setBannerStyle] = useState('positive')

    const [tableData, setTableData] = useState([])

    const columns = useMemo(() => {
        if (IS_USER) {
            return [
                {
                    size: 100,
                    maxSize: 100,
                    accessorKey: 'senderName',
                    header: 'Sender Name'
                },
                {
                    size: 100,
                    maxSize: 100,
                    accessorKey: 'senderNumber',
                    header: 'Sender Number (Operator Name)'
                },
                {
                    size: 50,
                    maxSize: 50,
                    accessorKey: 'documentType',
                    header: 'Document Type'
                },
                {
                    size: 200,
                    maxSize: 200,
                    accessorKey: 'sourceNumber',
                    header: 'Source Number (Owner Number)'
                }
            ]
        } else {
            return [
                {
                    size: 200,
                    maxSize: 200,
                    accessorKey: 'senderName',
                    header: 'Sender Name'
                },
                {
                    size: 200,
                    maxSize: 200,
                    accessorKey: 'senderNumber',
                    header: 'Sender Number (Operator #)'
                },
                {
                    size: 25,
                    maxSize: 25,
                    accessorKey: 'documentType',
                    header: 'Document Type'
                },
                {
                    size: 200,
                    maxSize: 200,
                    accessorKey: 'sourceNumber',
                    header: 'Source Number (Owner Number)'
                },
                {
                    header: 'Actions',
                    size: 60,
                    enableSorting: false,
                    maxSize: 60,
                    accesorKey: 'actions',
                    Cell: ({row}) => {
                        return (
                            <div className='d-flex align-items-center'>
                                <Tooltip content="Delete">
                                    <Trash3 
                                        className='payout-icon'
                                        size={15}
                                        onClick={() => handleRemoveClick(row.original.id)}
                                    />
                                </Tooltip>
                            </div>
                            
                        )
                    }
                }
            ]
        }
    })

    const clearBanner = () => {
        setDisplayBanner(false)
        setBannerMessage('')
        setBannerStyle('positive')
    }

    const displayErrorMessage = (message) => {
        setBannerMessage(message)
        setBannerStyle('negative')
        setDisplayBanner(true)

        setTimeout(() => {
            clearBanner()
        }, 5000)
    }

    const displaySuccessMessage = (message) => {
        setBannerMessage(message)
        setBannerStyle('positive')
        setDisplayBanner(true)

        setTimeout(() => {
            clearBanner()
        }, 5000)
    }

    const handleCreateLink = () => {
        setOpenModal(true)
    }

    const handleModalClose = () => {
        setOpenModal(false)
    }

    const loadPage = () => {
        if (!tableData.length)
            setIsLoading(true)
        else
            setIsFetching(true)

        axios.get('/GetOrganizationReceivers')
        .then(response => {
            // Organization Links
            const links = response.data
            setTableData(links)
        })
        .catch(err => {
            console.error(err)
        })
        .finally(() => {
            setIsLoading(false)
            setIsFetching(false)
        })
    }

    const handleModalSave = (payload) => {
        setOpenModal(false)
        setIsFetching(true)
        axios.post('/ValidateAndCreateOrganizationCompanyReceiver', payload)
            .then(response => {
                loadPage()
                displaySuccessMessage('Organization link successfully created')
            })
            .catch(err => {
                console.error(err)
                displayErrorMessage('There was an error creating the organization link')
            })
            .finally(() => {
            })
    }

    const handleRemoveClick = (rowId) => {
        // Implement BE call
        setIsFetching(true)
        axios
            .delete(`/DeleteOrganizationLink?organizationCompanyReceiverId=${rowId}`)
            .then(respnose => {
                loadPage()
                displaySuccessMessage('Organization link successfully deleted')
            })
            .catch(err => {
                console.error(err)
                displayErrorMessage('There was an error deleting     the organization link')
            })
            .finally(() => {
            })

    }

    useEffect(() => {
        loadPage()
    }, [])

    useEffect(() => {
        if (changedOrg){
            loadPage()
        }
    }, [changedOrg])

    return (
        <>
            <Grid item xs={12} lg={10}>
                <h4>Receiver Links to Senders</h4>
            </Grid>
            {!IS_USER && (
                <Grid item xs={12} lg={2}>
                    <Button className="secondary" onClick={handleCreateLink}>Create Link</Button>
                </Grid>
            )}
            {displayBanner && (
                <Grid item xs={12} mt={1}>
                    <AlertBanner backgroundColor={bannerStyle} isCloseHidden>
                        <AlertBannerText text={bannerMessage} />
                    </AlertBanner>
                </Grid>
            )}
            <Grid item xs={12} lg={12} mt={2}>
                <UITableReport 
                    columns={columns}
                    data={tableData}
                    isLoading={isLoading}
                    isFetching={isFetching}
                />
            </Grid>

            {openModal && (
                <OrganizationLinksModal 
                    open={openModal}
                    onClose={handleModalClose}
                    onSave={handleModalSave}
                />
            )}
        </>
    )
}

export default OrganizationLinks